<template>
  <div class="tl">
    <Breadcrumbs main="Рейтинг" title="Рейтинг турниров"/>

    <div class="container-fluid tl-container">

      <div class="tl-toolbar">
        <div class="tl-toolbar__main">
          <div class="tl-search" :class="{ 'is-busy': isLoadingRatingForTournaments }">
            <i class="fa fa-search tl-search__icon"></i>
            <input ref="search"
                   type="search"
                   class="tl-search__input"
                   v-model="searchModel"
                   placeholder="Поиск по ID или названию турнира…"
                   @keydown.esc.prevent="clearSearch"/>
            <button v-if="searchModel" type="button" class="tl-search__clear" @click="clearSearch">
              <i class="fa fa-times"></i>
            </button>
            <kbd v-else class="tl-search__kbd">/</kbd>
          </div>

          <div class="tl-spacer"></div>
        </div>

        <div v-if="searchApplied" class="rt-meta">
          <span class="rt-meta__chip">
            Поиск: «{{ searchApplied }}»
            <button type="button" @click="clearSearch"><i class="fa fa-times"></i></button>
          </span>
        </div>
      </div>

      <div class="tl-panel">
        <div v-if="isLoadingRatingForTournaments" class="tl-skeleton">
          <div v-for="n in 8" :key="'sk' + n" class="tl-skeleton__row">
            <span class="tl-sk tl-sk--sm"></span>
            <span class="tl-sk tl-sk--wide"></span>
            <span class="tl-sk"></span>
            <span class="tl-sk tl-sk--sm"></span>
          </div>
        </div>

        <div v-else-if="!rows.length" class="tl-empty">
          <div class="tl-empty__art"><i class="fa fa-trophy"></i></div>
          <div class="tl-empty__title">{{ searchApplied ? 'Ничего не нашлось' : 'Турниров нет' }}</div>
          <div class="tl-empty__text">
            {{ searchApplied ? 'Поиск работает по ID и названию турнира.' : 'Здесь появятся турниры с начисленным рейтингом.' }}
          </div>
          <div v-if="searchApplied" class="tl-empty__actions">
            <button type="button" class="tl-btn-ghost" @click="clearSearch">Сбросить поиск</button>
          </div>
        </div>

        <div v-else class="tl-table-wrap">
          <b-table class="tl-table rt-table"
                   responsive
                   hover
                   borderless
                   show-empty
                   :items="rows"
                   :fields="fields"
                   @row-clicked="openRatings">
            <template #cell(id)="{ item }">
              <button type="button" class="tl-id" @click.stop="copyId(item.id)"
                      v-b-tooltip.hover.right="'Скопировать ID турнира'">
                <span>#{{ item.id }}</span>
                <i class="fa fa-copy"></i>
              </button>
            </template>

            <template #cell(name)="{ item }">
              <div class="rt-team">
                <router-link class="rt-team__name"
                             :to="{ name: 'tournament_ratings_info', params: { id: item.id } }"
                             @click.native.stop>{{ item.name }}</router-link>
              </div>
            </template>

            <template #cell(end_time)="{ item }">
              <span :class="{ 'rt-dim': !item.end_time }">{{ formatEndTime(item.end_time, item.timezone) }}</span>
            </template>

            <!-- раньше строки с начисленным рейтингом просто желтели без подписи -->
            <template #cell(rated)="{ item }">
              <span v-if="item.team_ratings_count > 0" class="rt-chip rt-chip--ok">
                <i class="fa fa-check"></i> Начислен · {{ item.team_ratings_count }}
              </span>
              <span v-else class="rt-chip">Нет начислений</span>
            </template>

            <template #cell(action)="{ item }">
              <router-link class="tl-icon-btn rt-open"
                           :to="{ name: 'tournament_ratings_info', params: { id: item.id } }"
                           @click.native.stop
                           v-b-tooltip.hover.left="'Рейтинг команд турнира'">
                <i class="fa fa-angle-right"></i>
              </router-link>
            </template>
          </b-table>
        </div>

        <div v-if="!isLoadingRatingForTournaments && rows.length" class="tl-foot">
          <div class="tl-foot__info">
            Показано <b>{{ rangeFrom }}–{{ rangeTo }}</b> из <b>{{ total || 0 }}</b>
          </div>
          <b-pagination class="tl-pagination my-0"
                        v-model="currentPageModel"
                        :total-rows="total"
                        :per-page="perPage"
                        :limit="7"
                        @change="handlePageChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ModalAdapterMixin} from "@/mixins/modal/ModalAdapterMixin";
import {PaginationHelperMixin} from "@/mixins/Helpers/PaginationHelperMixin";
import {TournamentAdapterMixin} from "@/mixins/Tournament/TournamentAdapterMixin";
import {tournamentDate} from "@/common/tournamentTime";
import lodash from "lodash";

export default {
  name: "ListTournamentsRating",
  components: {},
  mixins: [ModalAdapterMixin, PaginationHelperMixin, TournamentAdapterMixin],
  created() {
    this.isLoadingRatingForTournaments = true
    this.recordPageToStorage(this.currentPage, this.pageKey)
    this.indexTournaments({
      pageNumber: this.getCurrentPageNumber(this.pageKey),
    }).then(() => this.isLoadingRatingForTournaments = false)
  },
  data() {
    return {
      searchForTournamentsRatingModel: '',
      pageKey: 'tournamentsRatingPageNumber',
      perPage: 10,
      debouncedSearch: lodash.debounce(function () {
        this.getFilteredTournamentsRating();
      }, 600),
      fields: [
        {key: 'id', label: 'ID', sortable: true, thClass: 'tl-th--id'},
        {key: 'name', label: 'Турнир', sortable: true},
        {key: 'end_time', label: 'Завершён', sortable: true},
        {key: 'rated', label: 'Рейтинг', sortable: false},
        {key: 'action', label: '', sortable: false, thClass: 'tl-th--act', tdClass: 'tl-td--act'},
      ],
      isLoadingRatingForTournaments: false
    };
  },
  computed: {
    rows() {
      return this.tournaments || [];
    },

    searchApplied() {
      return (this.searchForTournamentsRatingModel || '').trim();
    },

    searchModel: {
      get() { return this.searchForTournamentsRatingModel },
      set(value) {
        this.searchForTournamentsRatingModel = value;
        this.debouncedSearch();
      }
    },

    currentPageModel: {
      get() { return Number(this.currentPage) || 1 },
      set(value) { this.currentPage = value }
    },

    rangeFrom() {
      if (!this.rows.length) return 0;
      return (this.currentPageModel - 1) * this.perPage + 1;
    },

    rangeTo() {
      return (this.currentPageModel - 1) * this.perPage + this.rows.length;
    },
  },
  mounted() {
    window.addEventListener('keydown', this.focusSearch);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.focusSearch);
  },
  methods: {
    focusSearch(event) {
      if (event.key !== '/' || ['INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName)) return;
      event.preventDefault();
      if (this.$refs.search) this.$refs.search.focus();
    },

    clearSearch() {
      this.searchForTournamentsRatingModel = '';
      this.getFilteredTournamentsRating();
    },

    openRatings(item) {
      this.$router.push({name: 'tournament_ratings_info', params: {id: item.id}});
    },

    copyId(id) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(String(id)).then(() => {
          this.$toasted.success('ID турнира скопирован', {position: 'top-right', duration: 1500});
        }).catch(() => {
        });
      }
    },

    handlePageChange(pageNumber) {
      this.recordPageToStorage(pageNumber, this.pageKey)
      this.indexTournaments({
        pageNumber: pageNumber,
        ...(this.searchForTournamentsRatingModel && {search: this.searchForTournamentsRatingModel}),
      })
    },
    getFilteredTournamentsRating() {
      this.isLoadingRatingForTournaments = true
      this.indexTournaments({search: this.searchForTournamentsRatingModel})
          .then(() => {
            this.isLoadingRatingForTournaments = false
          })
    },
    /** Дата завершения приходит стенной в зоне турнира — приводим к локальной зоне админа. */
    formatEndTime(endTime, timezone) {
      const date = tournamentDate(endTime, timezone);
      if (!date) return '—';
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
    }
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/admin-list.scss";
@import "~@/assets/scss/rating-list.scss";

.tl { @include rating-list-parts; }
</style>
